<template>
  <div :style="{background: backgroundColor}">
    <!-- <Header :chosen-color="chosenColor" :colors="colors" /> -->
    <beautiful-chat
      :always-scroll-to-bottom="alwaysScrollToBottom"
      :close="closeChat"
      :colors="colors"
      :is-open="isChatOpen"
      :message-list="messageList"
      :message-styling="messageStyling"
      :new-messages-count="newMessagesCount"
      :on-message-was-sent="onMessageWasSent"
      :open="openChat"
      :participants="participants"
      :show-close-button="true"
      :show-launcher="true"
      :show-emoji="true"
      :show-file="true"
      :show-typing-indicator="showTypingIndicator"
      :title-image-url="titleImageUrl"
      :disable-user-list-toggle="false"
      @onType="handleOnType"
    >
    <!-- TOLTO CHE IL MESSAGGIO INVIATO SIA MODIFICABILE
        :show-edition="true"
        :show-deletion="true"
        @edit="editMessage"
        @remove="removeMessage" 
        -->
      <!--  POLLICE IN SU 
      <template v-slot:text-message-toolbox="scopedProps">
        <button
          v-if="!scopedProps.me && scopedProps.message.type === 'text'"
          @click.prevent="like(scopedProps.message.id)"
        >
          👍
        </button>
      </template> -->


      <!-- COLORI SELZIONABILI NON SERVE
       <template v-slot:text-message-body="scopedProps">
        <p class="sc-message--text-content" v-html="scopedProps.messageText"></p>
        <p
          v-if="scopedProps.message.data.meta"
          class="sc-message--meta"
          :style="{color: scopedProps.messageColors.color}"
        >
          {{ scopedProps.message.data.meta }}
        </p>
        <p
          v-if="scopedProps.message.isEdited || scopedProps.message.liked"
          class="sc-message--edited"
        >
          <template v-if="scopedProps.message.isEdited">✎</template>
          <template v-if="scopedProps.message.liked">👍</template>
        </p>
      </template> -->
      <!-- <template v-slot:system-message-body="{message}"> [System]: {{ message.text }} </template> -->
    </beautiful-chat>
    
    <v-dialog />
    <!-- <p class="text-center messageStyling">
      <label
        >Message styling enabled?
        <input checked type="checkbox" @change="messageStylingToggled" />
      </label>
      <a href="#" @click.prevent="showStylingInfo()">info</a>
    </p> -->
    <TestArea
      :chosen-color="chosenColor"
      :colors="colors"
      :message-styling="messageStyling"
      :on-message="sendMessage"
      :on-typing="handleTyping"
    />
    <!-- <Footer :chosen-color="chosenColor" :colors="colors" /> -->
  </div>
</template>

<script>
import messageHistory from './messageHistory'
// import chatParticipants from './chatProfiles'
import Header from '@/components/Chat/Header.vue'
import Footer from '@/components/Chat/Footer.vue'
import TestArea from '@/components/Chat/TestArea.vue'
// import availableColors from './colors'
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    TestArea
  },
  data() {
    return {
      participants: [
        // { id: 'mattmezza', name: 'Matteo', imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4' },
        { id: 'support', name: 'Support', imageUrl: 'https://avatars3.githubusercontent.com/u/37018832?s=200&v=4'}
      ],
      titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png',
      messageList: [{ type: 'text', author: `me`, id: 0, data: { text: `Prova` } },],//messageHistory,
      newMessagesCount: 0,
      isChatOpen: false,
      showTypingIndicator: '',
      colors: null,
      // availableColors: {
        color: {
          header: { bg: '#00467f', text: '#fff' },
          launcher: { bg: '#00467f'},
          messageList: { bg: '#fff' },
          sentMessage: { bg: '#00467f', text: '#fff'},
          receivedMessage: { bg: '#bdbebd', text: '#fff'},
          userInput: {  bg: '#fff', text: '#212121'},
          userList: { bg: '#fff', text: '#212121'}
        },
      // green: {
      //   header: { bg: '#388E3C',  text: '#fff'},
      //   launcher: { bg: '#388E3C'},
      //   messageList: { bg: '#fff'},
      //   sentMessage: { bg: '#4CAF50',text: '#fff'},
      //   receivedMessage: {bg: '#eaeaea', text: '#222222' },
      //   userInput: { bg: '#fff', text: '#212121' },
      //   userList: { bg: '#fff', text: '#212121' }
      // },
      // blue: {
      //   header: { bg: '#4e8cff', text: '#ffffff'},
      //   launcher: {  bg: '#4e8cff' },
      //   messageList: { bg: '#ffffff' },
      //   sentMessage: { bg: '#4e8cff', text: '#ffffff'},
      //   receivedMessage: { bg: '#eaeaea', text: '#222222'
      //   },
      //   userInput: {bg: '#f4f7f9', text: '#565867' },
      //   userList: {bg: '#fff', text: '#212121' }
      // },
      // dark: {
      //   header: { bg: '#34495e', text: '#ecf0f1' },
      //   launcher: { bg: '#34495e' },
      //   messageList: { bg: '#2c3e50' },
      //   sentMessage: { bg: '#7f8c8d', text: '#ecf0f1' },
      //   receivedMessage: { bg: '#95a5a6',text: '#ecf0f1' },
      //   userInput: { bg: '#34495e', text: '#ecf0f1' },
      //   userList: { bg: '#2c3e50', text: '#ecf0f1' }
      // }
      // },
      chosenColor: null,
      alwaysScrollToBottom: true,
      messageStyling: true,
      userIsTyping: false
    }
  },
  computed: {
    linkColor() {
      return this.chosenColor === 'dark' ? this.colors.sentMessage.text : this.colors.launcher.bg
    },
    backgroundColor() {
      return this.chosenColor === 'dark' ? this.colors.messageList.bg : '#fff'
    }
  },
  created() {
    this.setColor('blue')
  },
  mounted() {
    // this.messageList.forEach((x) => (x.liked = false))
  },
  methods: {
    sendMessage(text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
        this.onMessageWasSent({
          author: 'support',
          type: 'text',
          id: Math.random(),
          data: {text}
        })
      }
    },
    handleTyping(text) {
      this.showTypingIndicator =
        text.length > 0 ? this.participants[this.participants.length - 1].id : ''
    },
    onMessageWasSent(message) {
      this.messageList = [...this.messageList, Object.assign({}, message, {id: Math.random()})]
    },
    openChat() {
      this.isChatOpen = true
      this.newMessagesCount = 0
    },
    closeChat() {
      this.isChatOpen = false
    },
    setColor() {
      this.colors = this.color //availableColors['color']
      this.chosenColor = this.color
    },
    // showStylingInfo() {
    //   this.$modal.show('dialog', {
    //     title: 'Info',
    //     text:
    //       'You can use *word* to <strong>boldify</strong>, /word/ to <em>emphasize</em>, _word_ to <u>underline</u>, `code` to <code>write = code;</code>, ~this~ to <del>delete</del> and ^sup^ or ¡sub¡ to write <sup>sup</sup> and <sub>sub</sub>'
    //   })
    // },
    
    // messageStylingToggled(e) {
    //   this.messageStyling = e.target.checked
    // },
    handleOnType() {
      this.$root.$emit('onType')
      this.userIsTyping = true
    },
    // editMessage(message) {
    //   const m = this.messageList.find((m) => m.id === message.id)
    //   m.isEdited = true
    //   m.data.text = message.data.text
    // },
    // removeMessage(message) {
    //   if (confirm('Delete?')) {
    //     const m = this.messageList.find((m) => m.id === message.id)
    //     m.type = 'system'
    //     m.data.text = 'This message has been removed'
    //   }
    // },
    // like(id) {
    //   const m = this.messageList.findIndex((m) => m.id === id)
    //   var msg = this.messageList[m]
    //   msg.liked = !msg.liked
    //   this.$set(this.messageList, m, msg)
    // }
  }
}
</script>

<style>
body {
  padding: 0px;
  margin: 0px;
}
* {
  font-family: Avenir Next, Helvetica Neue, Helvetica, sans-serif;
}
.demo-description {
  max-width: 500px;
}
.demo-description img {
  max-width: 500px;
}
.demo-test-area {
  width: 300px;
  box-sizing: border-box;
}
.demo-test-area--text {
  box-sizing: border-box;
  width: 100%;
  margin: 0px;
  padding: 0px;
  resize: none;
  font-family: Avenir Next, Helvetica Neue, Helvetica, sans-serif;
  background: #fafbfc;
  color: #8da2b5;
  border: 1px solid #dde5ed;
  font-size: 16px;
  padding: 16px 15px 14px;
  margin: 0;
  border-radius: 6px;
  outline: none;
  height: 150px;
  margin-bottom: 10px;
}
.demo-monster-img {
  width: 400px;
  display: block;
  margin: 60px auto;
}
.text-center {
  text-align: center;
}
.colors a {
  color: #fff;
  text-decoration: none;
  padding: 4px 10px;
  border-radius: 10px;
}
.toggle a {
  text-decoration: none;
}
.messageStyling {
  font-size: small;
}
</style>